// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"783":"8012a9dc","897":"47575ad8"}[chunkId] + ".css";
};